import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto", // Optional: for smooth scrolling
    });
  }, [pathname]); // Re-run effect when pathname changes

  return null; // This component doesn't render anything
}

export default ScrollToTop;
